import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['María', 'Lucía', 'Valentina', 'Camila', 'Sofía', 'Carolina', 'Florencia', 'Agustina', 'Daniela', 'Romina', 'Paula', 'Natalia', 'Julieta', 'Micaela', 'Andrea', 'Laura', 'Gabriela', 'Mariana', 'Victoria', 'Celeste', 'Belén', 'Rocío', 'Soledad', 'Fernanda'];
const LOCATIONS = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'San Luis', 'Paraná', 'Bahía Blanca', 'Formosa', 'San Rafael', 'Río Cuarto', 'Tandil', 'CABA', 'Quilmes', 'Lanús', 'Morón', 'Tigre', 'Pilar'];
const TIMES = ['hace 30 segundos', 'hace 1 minuto', 'hace 2 minutos', 'hace 3 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 10 minutos', 'hace 12 minutos', 'hace 15 minutos'];
const PRODUCTS = ['Mega Pack Mamá Sin Estrés', 'Mega Pack Pro'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function generateNotification() {
  return {
    name: getRandomItem(NAMES),
    location: getRandomItem(LOCATIONS),
    time: getRandomItem(TIMES),
    product: getRandomItem(PRODUCTS),
    id: Date.now()
  };
}
export function SocialProofToast() {
  const [notification, setNotification] = useState<ReturnType<typeof generateNotification> | null>(null);
  const [visible, setVisible] = useState(false);
  const showNotification = useCallback(() => {
    const notif = generateNotification();
    setNotification(notif);
    setVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setVisible(false);
    }, 4000);
  }, []);
  useEffect(() => {
    // First notification after 8 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 8000);
    // Then every 10-15 seconds
    const interval = setInterval(() => {
      const delay = Math.random() * 5000; // 0-5s extra randomness
      setTimeout(() => {
        showNotification();
      }, delay);
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [showNotification]);
  return <div className="fixed bottom-4 left-4 z-[60] pointer-events-none" data-id="element-363">
      <AnimatePresence data-id="element-364">
        {visible && notification && <motion.div key={notification.id} initial={{
        x: -100,
        opacity: 0,
        scale: 0.8
      }} animate={{
        x: 0,
        opacity: 1,
        scale: 1
      }} exit={{
        x: -100,
        opacity: 0,
        scale: 0.8
      }} transition={{
        type: 'spring',
        damping: 20,
        stiffness: 300
      }} className="pointer-events-auto bg-white rounded-xl shadow-2xl border border-rose/20 px-4 py-3 max-w-[280px] flex items-start gap-3" data-id="element-365">
            {/* Green check circle */}
            <div className="w-8 h-8 rounded-full bg-emerald-500 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-366">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-367">
                <polyline points="20 6 9 17 4 12" data-id="element-368" />
              </svg>
            </div>

            <div className="min-w-0" data-id="element-369">
              <p className="text-charcoal text-xs font-bold leading-snug" data-id="element-370">
                {notification.name} de {notification.location}
              </p>
              <p className="text-charcoal/70 text-[11px] leading-snug mt-0.5" data-id="element-371">
                compró{' '}
                <span className="font-semibold text-coral" data-id="element-372">
                  {notification.product}
                </span>
              </p>
              <p className="text-charcoal/40 text-[10px] mt-1" data-id="element-373">
                🕐 {notification.time}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}